import React, { useState } from 'react';
import { Box, TextField, Button } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { useTranslation } from 'react-i18next';

// Inline quantity validation for add-to-cart: typing above (available −
// alreadyInCart) turns the field red with the exact maximum in the helper
// text and disables the button — never a post-submit alert.
const AddToCartControl = ({ available, alreadyInCart = 0, onAdd, unit, size = 'medium', fullWidth }) => {
  const { t } = useTranslation();
  const max = Math.max(0, (available || 0) - alreadyInCart);
  const [quantity, setQuantity] = useState(max > 0 ? '1' : '0');

  const numericQuantity = Number(quantity);
  const isInvalid = quantity === '' || Number.isNaN(numericQuantity) || numericQuantity <= 0 || numericQuantity > max;
  const helperText = max <= 0
    ? t('Out of stock', { defaultValue: 'Out of stock' })
    : numericQuantity > max
      ? t('Maximum you can add: {{max}}', { max, defaultValue: `Maximum you can add: ${max}` })
      : (alreadyInCart > 0 ? t('{{count}} already in cart', { count: alreadyInCart, defaultValue: `${alreadyInCart} already in cart` }) : ' ');

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, flexDirection: fullWidth ? 'column' : 'row' }}>
      <TextField
        type="text"
        inputMode="numeric"
        size={size}
        value={quantity}
        onChange={(e) => setQuantity(e.target.value.replace(/[^0-9]/g, ''))}
        error={max > 0 && numericQuantity > max}
        helperText={helperText}
        disabled={max <= 0}
        inputProps={{ style: { textAlign: 'center' } }}
        sx={{ width: fullWidth ? '100%' : 96 }}
      />
      <Button
        variant="contained"
        size={size}
        fullWidth={fullWidth}
        startIcon={<AddShoppingCartIcon fontSize="small" />}
        disabled={max <= 0 || isInvalid}
        onClick={() => { onAdd(numericQuantity); setQuantity(max > numericQuantity ? '1' : '0'); }}
      >
        {max <= 0 ? t('Out of Stock') : t('Add to Cart')}
      </Button>
    </Box>
  );
};

export default AddToCartControl;
